import { useEffect } from "react";

export default function Modal({ open, title, onClose, onSave, saveLabel = "Salva", children, saveDisabled = false }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="modal open" onClick={(e) => { if (e.target.classList.contains("modal")) onClose?.(); }}>
      <div className="dialog" role="dialog" aria-modal="true" data-testid="modal-dialog">
        <div className="dialog-head">
          <h3>{title}</h3>
          <button className="btn small" data-testid="modal-close-btn" onClick={onClose}>
            <i className="fa-solid fa-xmark" />
          </button>
        </div>
        <div className="dialog-body">{children}</div>
        <div className="dialog-foot">
          <button className="btn" onClick={onClose} data-testid="modal-cancel-btn">Annulla</button>
          <button className="btn primary" onClick={onSave} data-testid="modal-save-btn" disabled={saveDisabled}>
            <i className="fa-solid fa-check" /> {saveLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
